import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';

const columnsBase = [
  {
    field: 'radio',
    headerName: '',
    width: 50,
    sortable: false,
    renderCell: (params) => (
      <Radio
        checked={params.row.Reserv_Id === params.api.state.selectedRowId}
        onChange={() => params.api.setSelectedRow(params.row.Reserv_Id)}
        color="primary"
        size="small"
      />
    ),
  },
  { field: 'Reserv_Id', headerName: 'Id', width: 50 },
  {
    field: 'Type',
    headerName: 'Type',
    width: 70,
    editable: false,
  },
  {
    field: 'Full_Name',
    headerName: 'Full name',
    width: 120,
    editable: false,
  },
  {
    field: 'Reserv_Checkindate',
    headerName: 'Check in',
    width: 90,
  },
  {
    field: 'Reserv_Checkoutdate',
    headerName: 'Check out',
    width: 90,
  },
];

export default function ShowCheckIn_Data(props) {
  const [selectedRow, setSelectedRow] = React.useState(null);

  // برای استفاده در داخل renderCell
  const apiRef = React.useRef({});

  const handleSelectRow = (id) => {
    setSelectedRow(id);
    const row = props.data.find((r) => r.Reserv_Id === id);

    if (row) {
      localStorage.setItem('Reserv_Id', row.Reserv_Id);
      props.handleReservId(row.Reserv_Id);
      props.getpassno(row.Pass_No);
      if (row.Type === 'ChkIn' || row.Type ==='ChkOut') {
        if (props.CheckPerflag) props.Checkoutflag(true);
      } else {
        props.Checkoutflag(false);
      }
    }
  };

  const columns = React.useMemo(
    () =>
      columnsBase.map((col) =>
        col.field === 'radio'
          ? {
              ...col,
              renderCell: (params) => (
                <Radio
                  checked={selectedRow === params.row.Reserv_Id}
                  onChange={() => handleSelectRow(params.row.Reserv_Id)}
                  color="primary"
                  size="small"
                />
              ),
            }
          : col
      ),
    [selectedRow]
  );

  const ODD_OPACITY = 0.2;

  const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}`]: {
      '&.red': {
        backgroundColor: '#F2595C33',
      },
      '&.yellow': {
        backgroundColor: '#FFFACD',
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
      '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.main, 0.3),
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.4),
        },
      },
    },
  }));

  return (
    <Paper sx={{ height: 300, width: '100%' }}>
      <StripedDataGrid
        rows={props.data}
        columns={columns}
        getRowId={(row) => row.Reserv_Id}
        hideFooter
        disableRowSelectionOnClick
        rowHeight={32} // 👈 ارتفاع ردیف‌ها (پیش‌فرض 52 است)
        headerHeight={36} // 👈 ارتفاع هدرها هم می‌تونی کمتر کنی

        onRowClick={(params) => handleSelectRow(params.row.Reserv_Id)}
        sx={{
          border: 0,
          fontFamily: 'Roboto',
          fontSize: '10px',
        }}
        getRowClassName={(params) =>
          params.row.Type === 'Res' ? 'yellow' : 'red'
        }
      />
    </Paper>
  );
}
